"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Summary_1 = __importDefault(require("./Summary"));
class SummaryData {
    constructor({ label, sales, visitors, salesByVisitors, purchaseRates, purchasers, visitorsBySession, visitorsByPv, }) {
        this.toJSON = () => ({
            label: this.label,
            sales: this.sales,
            visitors: this.visitors,
            salesByVisitors: this.salesByVisitors,
            purchaseRates: this.purchaseRates,
            purchasers: this.purchasers,
            visitorsBySession: this.visitorsBySession,
            visitorsByPv: this.visitorsByPv,
        });
        this.label = label;
        this.sales = sales;
        this.visitors = visitors;
        this.salesByVisitors = salesByVisitors;
        this.purchaseRates = purchaseRates;
        this.purchasers = purchasers;
        this.visitorsBySession = visitorsBySession;
        this.visitorsByPv = visitorsByPv;
    }
}
SummaryData.fromJSON = (json) => {
    const { label, sales, visitors, salesByVisitors, purchaseRates, purchasers, visitorsBySession, visitorsByPv, } = Object.assign({}, json);
    if (typeof label !== 'string')
        throw new Error('.label must be a string');
    const _sales = typeof sales !== 'undefined' ? Summary_1.default.fromJSON(sales) : undefined;
    const _visitors = typeof visitors !== 'undefined' ? Summary_1.default.fromJSON(visitors) : undefined;
    const _salesByVisitors = typeof salesByVisitors !== 'undefined' ? Summary_1.default.fromJSON(salesByVisitors) : undefined;
    const _purchaseRates = typeof purchaseRates !== 'undefined' ? Summary_1.default.fromJSON(purchaseRates) : undefined;
    const _purchasers = typeof purchasers !== 'undefined' ? Summary_1.default.fromJSON(purchasers) : undefined;
    const _visitorsBySession = typeof visitorsBySession !== 'undefined' ? Summary_1.default.fromJSON(visitorsBySession) : undefined;
    const _visitorsByPv = typeof visitorsByPv !== 'undefined' ? Summary_1.default.fromJSON(visitorsByPv) : undefined;
    return new SummaryData({
        label,
        sales: _sales,
        visitors: _visitors,
        salesByVisitors: _salesByVisitors,
        purchaseRates: _purchaseRates,
        purchasers: _purchasers,
        visitorsBySession: _visitorsBySession,
        visitorsByPv: _visitorsByPv,
    });
};
exports.default = SummaryData;
